/**
 * True when Delete on the current vertex selection should remove the whole
 * {@link Shape} instead of deleting vertices one-by-one.
 *
 * Selecting every vertex (the cutout delete workaround) must not fall through
 * to triangle→draft mode. Cutouts also skip draft when the deletion would leave
 * fewer than three points — a 2-point cutout draft is not a useful edit path.
 */
export const shouldRemoveEntireShapeOnVertexDelete = (options: {
  selectedPointIndexes: readonly number[];
  shapePointCount: number;
  isCutout?: boolean;
}): boolean => {
  const { selectedPointIndexes, shapePointCount, isCutout } = options;
  if (shapePointCount < 3) return false;
  if (!selectedPointIndexes.length) return false;

  const unique = new Set(
    selectedPointIndexes.filter(
      (index) => index >= 0 && index < shapePointCount,
    ),
  );
  if (!unique.size) return false;

  // All vertices selected → remove the shape cleanly (no draft leftovers).
  if (unique.size >= shapePointCount) return true;

  // Cutout with too few points left would enter draw mode; delete the hole instead.
  if (isCutout === true && unique.size >= shapePointCount - 2) return true;

  return false;
};
